import React, { useEffect, useState } from 'react';
import { Box, Chip, Tab, Tabs, Typography } from '@mui/material';
import useActiveSite from '../../../hooks/useActiveSite';
import { Colors } from '../../../assets/theme/Colors';

const conversationHeaderTabSx = {
  minHeight: 28,
  minWidth: 'auto',
  px: 2,
  py: 0.5,
  borderRadius: 4,
  textTransform: 'none',
  fontWeight: 700,
  fontSize: 14,
  color: 'grayText',
  bgcolor: 'grey.100',
  '&.Mui-selected': {
    color: 'common.white',
    bgcolor: 'grey.900',
  },
};

const SDCustomListHeader = ({ session, activeTab, onTabChange, conversationListWidth }) => {
  const [conversations, setConversations] = useState([]);
  const activeSite = useActiveSite();

  useEffect(() => {
    const subscription = session.subscribeConversations((snapshot) => {
      setConversations(snapshot);
    });
    return () => subscription.unsubscribe();
  }, [session]);

  const totalOpenCount = conversations.filter((conversation) => conversation?.custom?.resolved === 'false').length;
  const totalResolvedCount = conversations.filter((conversation) => conversation?.custom?.resolved === 'true').length;
  const unreadMessageCount = conversations.reduce((total, c) => total + (c.unreadMessageCount || 0), 0);
  const unreadConversationCount = conversations.filter((c) => c.isUnread).length;

  return (
    <>
      <Box sx={{ px: 2, py: 1, borderBottom: 1, borderRight: 1, borderColor: 'divider' }}>
        <Box
          sx={{
            display: 'flex',
            gap: 1,
            alignItems: 'center',
          }}
        >
          <Typography
            variant="h6"
            noWrap
            sx={{
              fontWeight: 700,
              maxWidth: conversationListWidth,
            }}
          >
            Contact US - {activeSite?.name}
          </Typography>
          {(unreadMessageCount > 0 || unreadConversationCount > 0) && (
            <Chip
              label={`${unreadMessageCount || unreadConversationCount} unread`}
              size="small"
              sx={{ backgroundColor: Colors.chat.unread, color: 'common.white' }}
            />
          )}
        </Box>
        <Typography variant="caption" sx={{ color: 'grayText' }}>
          {activeTab === 'open' ? `${totalOpenCount} open` : `${totalResolvedCount} resolved`}
        </Typography>
      </Box>
      <Tabs
        value={activeTab}
        onChange={(e, newValue) => onTabChange(newValue)}
        sx={{
          px: 2,
          py: 1,
          borderRight: 1,
          borderColor: 'divider',
          '& .MuiTabs-flexContainer': {
            gap: 1,
          },
        }}
      >
        <Tab label="Open" value="open" sx={conversationHeaderTabSx} />
        <Tab label="Resolved" value="resolved" sx={conversationHeaderTabSx} />
      </Tabs>
    </>
  );
};

export default SDCustomListHeader;
